var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubCheck2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1f3060;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M906.54,995.85H178.71c-19.08-1.34-36.7-6.24-51.94-18.73-22.1-18.11-37.71-39.44-37.72-69.41,0-.92-.31-1.7-.88-2.39V177.48c2.54-12.59,1.98-25.72,8.79-37.55,12.86-22.33,30.61-38.98,54.36-48.85,10.78-4.48,22.56-4.9,34.02-4.9,238.13-.16,476.26.08,714.38-.28,48.85-.07,79.69,32.2,93.24,64.36,4.53,10.76,4.86,22.56,4.87,34.02.15,238.13.12,476.26.12,714.39,0,44.16-23.27,72.93-61.15,91.7-9.38,4.65-20.25,3.21-30.27,5.47Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M376.76,503.44c11.45.03,20.53,4.78,28.41,12.7,29.42,29.54,59.09,58.83,88.3,88.57,5.15,5.25,7.8,5.35,13.06.06,70.27-70.64,140.76-141.07,211.28-211.47,18.68-18.65,45.78-16.71,59.74,3.98,10.39,15.4,8.53,34.42-5.45,48.54-31.2,31.52-62.65,62.8-94,94.16-48.5,48.51-96.99,97.03-145.52,145.51-22.9,22.87-42.11,22.94-64.77.29-39.11-39.09-78.34-78.05-117.2-117.38-20.87-21.12-12.27-54.86,15.72-63.21,3.35-1,6.94-1.19,10.42-1.76Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubCheck2);
export default __webpack_public_path__ + "static/media/SubCheck2.6b1a42e8752a5b6388f2262acdd50de1.svg";
export { ForwardRef as ReactComponent };